export const serializeFiltersToQuery = (filters: Record<string, any>) => {
  const query: Record<string, string | string[]> = {};

  // Keys that should always be serialized with [] notation,
  // even if they have a single string value.
  const ALWAYS_ARRAY_KEYS = new Set([
    "city",
    "region",
    "district",
    "microdistrict",
    "street",
    "metroStation",
    "propertyType",
    "objectType",
    "districts",
    "features",
    "filterId",
    "rooms",
  ]);

  // Keys that represent nested DTOs and whose array values
  // should be transformed into object-like query params (e.g., amenities[pool]=true)
  const NESTED_DTO_KEYS = new Set([
    "amenities",
    "communications",
    "appliances",
    "infrastructure",
    "landscape",
    "comfort",
    "multimedia",
    "pets",
    "rentalOptions",

    // Add other similar keys here if they follow the same pattern
  ]);

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !(Array.isArray(value) && value.length === 0) &&
      // Ensure that numeric zero is still serialized if it's not explicitly excluded elsewhere for other reasons
      // For example, if a filter could legitimately be `count=0`.
      // The original check `!(typeof value === "number" && value === 0)` is kept
      // if we want to skip serializing zero numbers.
      // If you want to include 0 for numeric fields, you might remove this part of the condition.
      !(
        typeof value === "number" &&
        value === 0 &&
        key !== "totalPriceMin" &&
        key !== "pricePerSqMMin" &&
        key !== "areaMin" &&
        key !== "floorMin" &&
        key !== "floorsMin" &&
        key !== "downPaymentMin" &&
        key !== "completionYearMin" &&
        key !== "ceilingHeightMin"
      )
    ) {
      if (NESTED_DTO_KEYS.has(key) && Array.isArray(value)) {
        // Handle nested DTOs represented as arrays of strings
        value.forEach((item: string) => {
          query[`${key}[${item}]`] = "true";
        });
      } else if (ALWAYS_ARRAY_KEYS.has(key)) {
        const _key = `${key}[]`;
        if (Array.isArray(value)) {
          query[_key] = value.map(String);
        } else {
          // If it's an "always-array" key but has a single value, wrap it in an array
          query[_key] = [String(value)];
        }
      } else if (Array.isArray(value)) {
        // If array (and not in ALWAYS_ARRAY_KEYS or NESTED_DTO_KEYS), add [] to key
        const _key = `${key}[]`;
        query[_key] = value.map(String);
      } else {
        query[key] = value.toString();
      }
    }
  });

  return query;
};
